import React from 'react';
import { motion } from 'framer-motion';
export function CreatorQuote() {
  return <section className="py-10 sm:py-12 px-4 bg-brand-dark border-y border-white/5" data-id="element-68">
      <div className="max-w-3xl mx-auto text-center" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-70">
          <h3 className="text-xl font-bold text-brand-orange uppercase mb-8 tracking-widest" data-id="element-71">
            Chi ha creato questo sistema
          </h3>

          <blockquote className="text-xl sm:text-2xl font-medium text-brand-cream italic leading-relaxed mb-8" data-id="element-72">
            "Ho riunito in questo Metodo le risorse operative reali per
            trasformare lezioni improvvisate in percorsi didattici
            professionali, documentati e riconoscibili dal MIM. Meno ricerca
            disperata su internet. Più passione per l'economia aziendale. Più
            tempo libero per te."
          </blockquote>

          <div className="font-black text-gray-400 text-lg" data-id="element-73">
            — Metodo Economia Aziendale Pro™ · Sistema Didattico Integrato per
            Docenti di Economia Aziendale ITE
          </div>
        </motion.div>
      </div>
    </section>;
}